export const FETCH_CONTACTS = "FETCH_CONTACTS";
export const ADD_MESSAGE = "ADD_MESSAGE";
